import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'

const listUploads = (launchId: string): Promise<AxiosResponse> =>
  Request.get(`/hr/reported_usage/uploads/?launch_id=${encodeURIComponent(launchId)}`)

const uploadFile = (
  launchId: string,
  merchant: string,
  file: File
): Promise<AxiosResponse> => {
  const body = new FormData()
  body.append('launch_id', launchId)
  body.append('merchant', merchant)
  body.append('file', file)
  return Request.post('/hr/reported_usage/uploads/', body, 'formData')
}

const downloadUpload = (uploadId: string): Promise<AxiosResponse> =>
  Request.get(`/hr/reported_usage/uploads/${uploadId}/download/`)

const ReportedUsageService = {
  listUploads,
  uploadFile,
  downloadUpload,
}

export default ReportedUsageService
